export default "__VITE_ASSET__903a03eb__"